import { createContext, useContext } from 'react'

interface NavigationBlockerContextType {
  blockNavigation: (callback: (path: string) => boolean) => void
  showNavigationDialog: (path: string) => void
  shouldBlockNavigation: (path: string) => boolean
  pendingNavigation: string | null
  confirmNavigation: () => void
  cancelNavigation: () => void
}

export const NavigationBlockerContext =
  createContext<NavigationBlockerContextType>({
    blockNavigation: () => {},
    showNavigationDialog: () => {},
    shouldBlockNavigation: () => false,
    pendingNavigation: null,
    confirmNavigation: () => {},
    cancelNavigation: () => {},
  })

export function useNavigationBlockerContext() {
  return useContext(NavigationBlockerContext)
}
